import { deniedGoogleConsent, subscribeToConsent } from './consent';

// Load GTM once through a provider-neutral consent interface shared by Arena and player entrypoints.
export const initGoogleTagManager = () => {
	const config = window.asportGoogleTagManagerConfig;
	if (!config?.id || window.asportGoogleTagManagerInitialized) return;
	window.asportGoogleTagManagerInitialized = true;
	window.dataLayer = window.dataLayer || [];
	let loaded = false;
	let previousGoogleConsent;
	let previousContainerEvent;
	let unsubscribe;

	// Use the gtag command format without replacing the CMP's own global functions.
	const queueConsent = function() {
		window.dataLayer.push(arguments);
	};
	const handleConsent = (state) => {
		const google = state.hasExplicitChoice && state.tagManagerAllowed ? state.google : deniedGoogleConsent();
		const snapshot = JSON.stringify(google);
		if (snapshot !== previousGoogleConsent) {
			// The local CMP already publishes updates. Echoing them would feed our denied state back into its adapter.
			if (!state.googleConsentPublished) queueConsent('consent', 'update', google);
			previousGoogleConsent = snapshot;
		}
		if (!loaded && state.hasExplicitChoice && state.tagManagerAllowed && Object.values(google).includes('granted')) {
			loaded = true;
			window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
			const script = document.createElement('script');
			script.async = true;
			script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(config.id)}`;
			document.head.appendChild(script);
		}
		if (loaded && state.containerEvent) {
			const eventSnapshot = JSON.stringify(state.containerEvent);
			if (eventSnapshot !== previousContainerEvent) {
				window.dataLayer.push(state.containerEvent);
				previousContainerEvent = eventSnapshot;
			}
		}
	};
	const subscribe = () => { unsubscribe = subscribeToConsent(config.provider, config.source, handleConsent); };
	subscribe();
	window.addEventListener('pagehide', () => unsubscribe());
	// BFCache restores this loader rather than executing the entrypoint again.
	window.addEventListener('pageshow', (event) => { if (event.persisted) subscribe(); });
};
